import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/constants/content";

export default function Testimonials() {
  return (
    <section className="section bg-[#F8FAFC]" data-testid="testimonials-section">
      <div className="container-page">
        <div className="max-w-2xl">
          <div className="eyebrow mb-3">Real Families, Real Stories</div>
          <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Trusted by families <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">across Delhi NCR</span>.
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.slice(0, 6).map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
              className="rounded-2xl bg-white p-6 border border-slate-200/70 shadow-sm hover:shadow-xl transition-shadow relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="h-6 w-6 absolute top-5 right-5" style={{ color: '#0A84FF', opacity: 0.25 }} />
              <div className="flex items-center gap-3 mb-4">
                <img src={t.image} alt={t.name} className="h-12 w-12 rounded-full object-cover ring-2 ring-[#0A84FF]/15" />
                <div>
                  <div className="font-display font-semibold text-slate-900 text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role} · {t.location}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">{t.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
